import React from 'react';

const PrivacyPolicyPage = () => {
  return (
      <section className='privacy-policy'>
        <div className='privacy-policy__container'>
          <h1 className='privacy-policy__main-title'>Terms of Use and Privacy Policy</h1><br/><br/>

          <p className='privacy-policy__text'>
            This Terms of Use and Privacy Policy (hereinafter referred to as the "Agreement") establishes the terms of use for the mobile application <strong>"Periodic Table"</strong> (hereinafter "App") and is concluded between <strong>Chernykh Nikita</strong> (Chernykh Technology), hereinafter referred to as the "Licensor," and any person using the App, hereinafter referred to as the "User."
          </p>

          <h3 className='privacy-policy__subtitle'>1. License Grant</h3>
          <p className='privacy-policy__text'>
            1.1. The Licensor grants the User a free, non-exclusive license to use the mobile application globally for personal, non-commercial purposes.<br />
            1.2. The Agreement does not grant the User an exclusive right to the mobile application; the Licensor remains the owner of all intellectual property rights.
          </p>

          <h3 className='privacy-policy__subtitle'>2. Purchases and Subscriptions</h3>
          <p className='privacy-policy__text'>
            2.1. <strong>Extended Functionality:</strong> The Licensor provides the opportunity to purchase extended functionality via a Subscription or a One-time Purchase (Lifetime access).<br />
            2.2. <strong>Payment:</strong> Payments are processed via <strong>Google Play Billing</strong>. Payment will be charged to your Google Account at confirmation of purchase.<br />
            2.3. <strong>Subscriptions:</strong> Subscription automatically renews unless auto-renew is turned off at least 24-hours before the end of the current period.<br />
            2.4. You can manage your subscriptions and cancel them in your Google Play Store settings.
          </p>

          <h3 className='privacy-policy__subtitle'>3. Information Collection and Use</h3>
          <p className='privacy-policy__text'>
            3.1. <strong>Authentication:</strong> When you use Google or Apple Sign-In, we collect your email address, name, and profile picture (avatar) solely to create and manage your account and synchronize your progress (XP, Ranks) across devices.<br />
            3.2. <strong>Log Data:</strong> We use third-party services like <strong>Google Firebase</strong> to collect data in case of an error (Crashlytics). This data may include your device's IP address, device name, operating system version, and the time/date of the error.<br />
            3.3. <strong>Internal Surveys:</strong> We may occasionally offer voluntary in-app surveys to improve our product. Data collected is anonymous and used solely for development.
          </p>

          <h3 className='privacy-policy__subtitle'>4. No Advertisements</h3>
          <p className='privacy-policy__text'>
            We respect your privacy. This App <strong>does not</strong> display third-party advertisements, nor do we share your data with advertising networks for marketing purposes.
          </p>

          <h3 className='privacy-policy__subtitle'>5. Account Deletion (Your Rights)</h3>
          <p className='privacy-policy__text'>
            5.1. You have the right to delete your account and all associated data at any time.<br />
            5.2. <strong>How to delete:</strong> You can request deletion directly within the App by navigating to <em>Settings {'>'} Delete Account</em>.<br />
            5.3. <strong>Consequences:</strong> Upon confirmation, your profile, game history, earned XP, ranks, and learning progress will be <strong>permanently deleted</strong> from our servers. This action is irreversible.
          </p>

          <h3 className='privacy-policy__subtitle'>6. Prohibited Actions</h3>
          <p className='privacy-policy__text'>
            The User is not allowed to modify, decompile, disassemble, decrypt, extract content, or create derivative works using the mobile application without the Licensor's prior written permission.
          </p>

          <h3 className='privacy-policy__subtitle'>7. Security, Anti-Fraud, and Zero Tolerance Policy</h3>
          <p className='privacy-policy__text'>
            7.1. <strong>Integrity of the App:</strong> We employ advanced security measures to detect unauthorized modifications, tampering, or reverse engineering of the App's code (including modified APKs).<br />
            7.2. <strong>Bypassing Payments:</strong> Any attempt to bypass the payment system, use "crack" tools, emulators, or unauthorized scripts to obtain paid functionality for free is a violation of international copyright laws and this Agreement.<br />
            7.3. <strong>Consequences:</strong> Upon detection of such activities, the Licensor reserves the right to:
            <ul className='privacy-policy__list'>
              <strong>Immediately and permanently ban</strong> your account and Device ID without prior notice.<br/>
              <strong>Wipe all progress</strong> and data associated with the account.<br/>
              <strong>Report</strong> the incident and your identifiers to Google and relevant law enforcement authorities for potential legal prosecution.<br/>
            </ul>
          </p>

          <h3 className='privacy-policy__subtitle'>8. Third-Party Services</h3>
          <p className='privacy-policy__text'>
            The App uses third-party services that may collect information used to identify you. Links to privacy policies of third-party service providers used by the App:
          </p>
          <ul className='privacy-policy__list'>
            <a className='privacy-policy__link' href="https://policies.google.com/privacy">- Google Play Services</a><br/>
            <a className='privacy-policy__link' href="https://firebase.google.com/policies/analytics">- Google Analytics for Firebase</a><br/>
            <a className='privacy-policy__link' href="https://firebase.google.com/support/privacy/">- Firebase Crashlytics</a>
        </ul>

          <h3 className='privacy-policy__subtitle'>9. Contact Us</h3>
          <p className='privacy-policy__text'>
            If you have any questions about this Privacy Policy or need assistance with account management/deletion, please contact us at:<br />
            <a className='privacy-policy__link' href='mailto:nks199731@gmail.com'>nks199731@gmail.com</a>
          </p>
        </div>
      </section>
  );
};

export default PrivacyPolicyPage;